import { render, staticRenderFns } from "./DigitalDay.vue?vue&type=template&id=65d2c097&scoped=true&"
import script from "./DigitalDay.vue?vue&type=script&lang=js&"
export * from "./DigitalDay.vue?vue&type=script&lang=js&"
import style0 from "./DigitalDay.vue?vue&type=style&index=0&id=65d2c097&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d2c097",
  null
  
)

export default component.exports